function loadLanding(view) {
    return () => import( /* webpackChunkName: "landing-[request]" */ `@/components/dashboard/landing/${view}.vue`)
}

const routes = [
    {
        path: 'type-informasi',
        name: 'AnnouncementType',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadLanding('AnnouncementType'),
    },
    {
        path: 'informasi',
        name: 'Announcement',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadLanding('Announcement'),
    },
    {
        path: 'slider',
        name: 'Slider',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadLanding('Slider'),
    },
    {
        path: 'faq',
        name: 'Faq',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak', 'crew']
        },
        component: loadLanding('Faq'),
    },
]

export default routes